import React from 'react';
import { Navbar, Nav, Container, Form, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = React.useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
    }
  };

  return (
    <header>
      <Navbar bg="dark" variant="dark" expand="lg" className="py-3">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <strong>Jamaica Directory</strong>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/category/historic-sites">Historic Sites</Nav.Link>
              <Nav.Link as={Link} to="/category/restaurants">Restaurants</Nav.Link>
              <Nav.Link as={Link} to="/category/pet-services">Pet Services</Nav.Link>
              <Nav.Link as={Link} to="/category/marinas">Marinas</Nav.Link>
              <Nav.Link as={Link} to="/category/golf-courses">Golf Courses</Nav.Link>
              <Nav.Link as={Link} to="/investor-resources">Investor Resources</Nav.Link>
              <Nav.Link as={Link} to="/relocation-guide">Relocation Guide</Nav.Link>
            </Nav>
            <Form className="d-flex" onSubmit={handleSearch}>
              <Form.Control
                type="search"
                placeholder="Search"
                className="me-2"
                aria-label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button variant="outline-success" type="submit">Search</Button>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
